import {
  faBook,
  faCalendarAlt,
  faCog,
  faHome,
  faTools, 
  faSync
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { createBrowserHistory } from "history";
import PropTypes from "prop-types";
import React, { PureComponent } from "react";
import onClickOutside from "react-onclickoutside";
import { Link } from "react-router-dom";
import ManagementTools from "../../../../ManagementTools/ManagementTools";
import { headerConstants } from "../../../constants";
import { connect } from "react-redux";

const history = createBrowserHistory();

class HeaderIcons extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      isOpenResources: false,
      isOpenSettings: false,
      enabledColor: false,
    };
    this.toggleColorPallet = this.toggleColorPallet.bind(this);
    this.changeDropDown = this.changeDropDown.bind(this);
    this.openModal = this.openModal.bind(this);
  }


  toggleColorPallet = () => {
    const { enabledColor } = this.state;
    const contentElement = document.querySelector(".content-wrap-body");
    this.setState(
      {
        enabledColor: !enabledColor,
      },
      () => {
        if (!enabledColor) {
          contentElement.classList.add("neutral-pallet");
        } else {
          contentElement.classList.remove("neutral-pallet");
        }
      }
    );
  };

  openModal = (id) => () => {
    const { getClientUsers, authData, showModal } = this.props;
    this.setState({ listId: id, activeDropDown: false });
    if (id === "userList") {
      getClientUsers(authData.ClientId);
    }
    showModal(`Management-tools-${id}`);
  };

  renderResources = () => {
    const { authData } = this.props;
    return (
      <div className="resources-dropdown">
        {headerConstants.resources.map((item) => {
          return (
            <Link
              key={item.link}
              className={`resources-link ${
                authData.Permissions.includes(item.permission) ? "" : "disabled"
              }`}
              to={item.link}
            >
              {item.title}
            </Link>
          );
        })}
      </div>
    );
  };

  openUrlInBrowser = (url) => () => {
    if (url && url.length !== 0) {
      window.open(url);
    }
  };

  renderTools = () => {
    const { authData } = this.props;

    return headerConstants.tools.length > 0 ? (
      <div className="tools-dropdown">
        {headerConstants.tools.map((item) => {
          return (
            <div
              key={item.link}
              className={`tools-link ${
                authData.Permissions.includes(item.permission) ? "" : "disabled"
              }`}
              onClick={this.openUrlInBrowser(item.link)}
            >
              {item.title}
            </div>
          );
        })}
      </div>
    ) : null;
  };

  renderSettings = (isActive) => {
    const enabledColor = this.state.enabledColor;
    const className = isActive === "settings" ? "" : "d-none";
    return (
      <div className={`settings-dropdown ${className}`}>
        <div className="switcher" onClick={this.toggleColorPallet}>
          <div className="switch-wrap">
            <span className="switch-button-text">Neutral Color Pallet</span>
            <div
              className={`switch-btn ${enabledColor ? "enabled" : "disabled"}`}
            />
          </div>
        </div>
      </div>
    );
  };

  handleClickOutside = () => {
    this.setState({ activeDropDown: false });
  };

  changeDropDown = (type) => () => {
    // if (
    //   event.target.parentNode.classList.contains("header-icons") ||
    //   event.target.classList.contains("header-icons") ||
    //   event.target.parentNode.classList.contains("tools-dropdown")
    // ) {
    // if (type === this.state.activeDropDown) {
    //   this.setState({ activeDropDown: false });
    // } else {
    this.setState({ activeDropDown: type });
    //}
    //}
  };

  render() {
    const { location, onClick } = this.props;
    const { activeDropDown } = this.state;
    const { listId } = this.state;
    const disabledIconClass = "disabled";
    return (
      <div className="header-icons-section">          
        {
          location === "/" ? 
          <a onClick={() => {window.location.href="/"}}>
          <FontAwesomeIcon icon={faSync} className={`header-icons--home header-icons `} />
          </a>
          : 
          <Link to="/">
            <FontAwesomeIcon
            icon={faHome}
            className={`header-icons--home header-icons ${
              location === "/" ? "d-none" : ""
            }`}
            />
          </Link>
        }
        
        <div className="resources-block" onClick={this.changeDropDown("tools")}>
          <FontAwesomeIcon
            icon={faTools}
            className={`header-icons--library header-icons ${
              activeDropDown === "tools" ? " active" : ""
            }`}
          />
          {this.renderTools()}
        </div>
        <div
          className="resources-block"
          onClick={this.changeDropDown("resources")}
        >
          <FontAwesomeIcon
            icon={faBook}
            className={`header-icons--library header-icons ${
              location === "/meetingdates" ? " active" : ""
            }`}
          />
          {this.renderResources()}
        </div>
        <a href="#">
          <FontAwesomeIcon
            icon={faCalendarAlt}
            className={`header-icons--calendar header-icons ${
              activeDropDown === "calendar" || history.pathname === "/calendar"
                ? "active"
                : ""
            }
            ${disabledIconClass}`}
          />
        </a>
        <div onClick={this.changeDropDown("settings")}>
          <FontAwesomeIcon
            icon={faCog}
            className={`header-icons--settings header-icons ${
              activeDropDown === "settings" ? "active" : ""
            }
            ${disabledIconClass}`}
          />
          {this.renderSettings(activeDropDown)}
        </div>
        <ManagementTools listId={listId} />
        <div
          className="header-sign-in track-green-button mr-0"
          onClick={onClick}
        >
          Sign out
        </div>
      </div>
    );
  }


  static propTypes = {
    onClick: PropTypes.func,
    location: PropTypes.string,
    showModal: PropTypes.func,
    authData: PropTypes.object,    
    getClientUsers: PropTypes.func,
  };  
}

export default onClickOutside(HeaderIcons);



// WEBPACK FOOTER //
// ./src/components/Header/components/IntranetSide/components/HeaderIcons.js